import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPostCustomSlider"] */ "/app/views/Blog/BlogPost/BlogPostCustomSlider.tsx");
